import axios from "axios";

class PasswordManagmentService {


    async set(data) {
        return await axios.post(`/api/v1/password-mgmt`, data).then(response => response.data);
    }


    async get() {
        return await axios.get('/api/v1/password-mgmt')
            .then(response => response.data);
    }
}

const passwordManagmentService = new PasswordManagmentService();
export default passwordManagmentService;